// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../log-in-vue/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navbar[data-v-b3f27202]{background-color:#fff;border-color:#c6c6c6}.navbar-toggler[data-v-b3f27202]{padding-top:6px!important;padding-bottom:4px!important;margin-left:5px!important;border-color:#ddd!important;max-width:8%!important}.navbar-light .navbar-nav .nav-link[data-v-b3f27202]{font-size:90%;font-weight:700;color:#333!important}@media (min-width:992px){.navbar-light .navbar-nav .nav-link[data-v-b3f27202]{padding:30px 20px 10px 20px}}", ""]);
// Exports
module.exports = exports;
